import React from 'react';
import { Box, Typography } from '@mui/material';
import { useMatchingStore } from '../../../store';
import MatchSuggestionsSearch from '../../../components/trip-request-matching/match-suggestions-search';
import MatchSuggestionsSection from '../../../components/trip-request-matching/match-suggestions-section';

const TripMatchingContainer = () => {
  const {
    isLoading,
    suggestionsList,
  } = useMatchingStore();

  return (
    <Box>
      <Typography variant="h3" mb={1}>
        Search Partners
      </Typography>
      <Typography color="primary.light" mb={2}>
        Filter by country to find partners for this trip.
      </Typography>
      <MatchSuggestionsSearch />
      <MatchSuggestionsSection
        categoryTitle="New"
        isLoading={isLoading}
        key="NEW"
        suggestions={suggestionsList.NEW}
      />
      <MatchSuggestionsSection
        categoryTitle="Priority Match"
        defaultExpanded
        isLoading={isLoading}
        key="PRIORITY"
        suggestions={suggestionsList.PRIORITY}
      />
      <MatchSuggestionsSection
        categoryTitle="Second Match"
        isLoading={isLoading}
        key="SECOND_MATCH"
        suggestions={suggestionsList.SECOND_MATCH}
      />
      <MatchSuggestionsSection
        categoryTitle="Third Match"
        isLoading={isLoading}
        key="THIRD_MATCH"
        suggestions={suggestionsList.THIRD_MATCH}
      />
      <MatchSuggestionsSection
        categoryTitle="Last Resort"
        isLoading={isLoading}
        key="LAST_RESORT"
        suggestions={suggestionsList.LAST_RESORT}
      />
    </Box>
  );
};

export default TripMatchingContainer;
